import DeepikaProfile from "../../../assets/Dheepika-52.png";
import VigneshProfile from "../../../assets/Vignesh.png";
import VetriProfile from "../../../assets/Vetri.png";
import shanmugaraj from "../../../assets/Shanmugaraj.png";
import Abdul from "../../../assets/Abdul Salam.png";

export const CreativesTeamProfile = [
  // { id: 1, title: "Deepika M", imgUrl: DeepikaProfile },
  { id: 1 ,title: "Shanmugaraj T", imgUrl: shanmugaraj },
  // { id: 4, title: "Vignesh K", imgUrl: VigneshProfile },
  // { id: 2, title: "Abdul Salam Irfan A", imgUrl: Abdul },
];
